import type { CSSProperties } from "react";

interface DataCopilotIconProps {
  size?: number;
  style?: CSSProperties;
}

export const DataCopilotIcon = ({ size = 20, style }: DataCopilotIconProps) => (
  <svg
    viewBox="0 0 32 32"
    width={size}
    height={size}
    fill="none"
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect x="1" y="3" width="30" height="27" rx="10" fill="#4a9e6e" />
    <rect x="13" y="0" width="6" height="5" rx="3" fill="#4a9e6e" />
    <circle cx="11.5" cy="15" r="3.5" fill="white" opacity="0.95" />
    <circle cx="20.5" cy="15" r="3.5" fill="white" opacity="0.95" />
    <circle cx="12.5" cy="14.5" r="1.5" fill="#2a5e42" />
    <circle cx="21.5" cy="14.5" r="1.5" fill="#2a5e42" />
    <circle cx="13.2" cy="13.5" r="0.7" fill="white" />
    <circle cx="22.2" cy="13.5" r="0.7" fill="white" />
    <path
      d="M12 22q4 2.5 8 0"
      stroke="white"
      strokeWidth="1.6"
      strokeLinecap="round"
      fill="none"
      opacity="0.85"
    />
  </svg>
);
